export const addHoliday = '/holidays';
export const holidayList = '/holidays';
export const deleteHoliday = '/holidays/';
export const updateHoliday = '/holidays/';
